/**
 * showToast - Provider mount 여부와 무관하게 어디서든 호출 가능한 글로벌 토스트 함수.
 *
 * Provider mount 전 호출은 큐에 저장 후, ToastProvider mount 시 flush 된다.
 * 호출자: services/apiClient, websocketClient, 비-React 모듈 포함.
 */

const MAX_PENDING = 20;
let toastInstance = null;
const pendingQueue = [];

/**
 * ToastProvider mount/unmount 시 호출. inst=null 이면 unmount.
 */
export const registerToastInstance = (inst) => {
    toastInstance = inst;
    if (!inst) return;
    while (pendingQueue.length > 0) {
        const opts = pendingQueue.shift();
        try {
            inst.show(opts);
        } catch (err) {
            console.error("[showToast] flush failed", err);
        }
    }
};

/**
 * 토스트를 표시한다.
 *
 * @param {{type: "error"|"success"|"info", message: string, duration?: number}} options
 */
export const showToast = (options) => {
    if (!options || !options.message) return;
    if (!toastInstance) {
        if (pendingQueue.length >= MAX_PENDING) {
            pendingQueue.shift();
            console.warn("[showToast] pendingQueue cap reached (20), oldest dropped");
        }
        pendingQueue.push(options);
        return;
    }
    toastInstance.show(options);
};
